import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class UtilsService
{
  constructor(@Inject(PLATFORM_ID) private platformId: Object) { }

  getContainerMargins(containerId: string): number
  {
    if (isPlatformBrowser(this.platformId))
    {
      const container = document.getElementById(containerId);
      if (container)
      {
        const computedStyle = getComputedStyle(container);
        const marginLeft = parseFloat(computedStyle.marginLeft);
        const paddingLeft = parseFloat(computedStyle.paddingLeft);

        return marginLeft + paddingLeft;
      }
    }
    return 0;
  }
}
